module.exports = __webpack_public_path__ + "static/img/point-font-img@mt.9aa6641.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/point-font-img@mt.png
// module id = NVhL
// module chunks = 0